import React from 'react';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const AnimatedSection = ({ 
  children, 
  animation = 'fadeInUp',
  delay = 0,
  duration = '0.65s',
  ...props 
}) => {
  // Use better thresholds for more reliable animations
  const threshold = useBreakpointValue({ base: 0.1, md: 0.15 }, { fallback: 'base' });
  
  const [ref, isVisible] = useScrollAnimation({ 
    threshold, 
    delay,
    triggerOnce: true,
    rootMargin: '0px 0px -10% 0px' // Trigger animations when element is 10% into viewport
  });

  const getAnimationStyles = () => {
    const baseStyles = {
      transition: `all ${duration} cubic-bezier(0.16, 1, 0.3, 1)`,
      willChange: 'transform, opacity', // Optimize for animations
    };

    switch (animation) {
      case 'fadeInUp':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
        };
      case 'fadeInDown':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(-24px)',
        };
      case 'fadeInLeft':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0)' : 'translateX(-24px)',
        };
      case 'fadeInRight':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0)' : 'translateX(24px)',
        };
      case 'scaleIn':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(0.8)',
        };
      case 'slideInUp':
        return {
          ...baseStyles,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          opacity: isVisible ? 1 : 0,
        };
      case 'rotateIn':
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'rotate(0deg) scale(1)' : 'rotate(-5deg) scale(0.9)',
        };
      default:
        return {
          ...baseStyles,
          opacity: isVisible ? 1 : 0,
        };
    }
  };

  return (
    <Box
      ref={ref}
      style={getAnimationStyles()}
      {...props}
    >
      {children}
    </Box>
  );
};

export default AnimatedSection;
